// src/services/firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);
export const auth = getAuth(app);

// Collection names
export const COLLECTIONS = {
  ASSESSMENT_TASKS: 'taskdata-tasks',
  TASK_SUBMISSIONS: 'taskdata-submissions', 
  LEARNER_MARKS: 'taskdata-marks',
  ITEMISED_MARKS: 'taskdata-itemised-marks',
  LEARNERS: 'taskdata-learners',
  LEARNER_DOCUMENTS: 'taskdata-learner-documents',
  QUESTIONS: 'taskdata-questions',
  REPORTS: 'taskdata-reports',
  USERS: 'taskdata-users',

  SESSIONS: 'taskdata-sessions',
  ATTENDANCE_SESSIONS: 'taskdata-attendance-sessions',
  ATTENDANCE_REGISTERS: 'taskdata-attendance-registers',
  GROUP_ATTENDANCE: 'taskdata-group-attendance',
  ATTENDANCE: 'taskdata-attendance',
  
  // Subscription Collections  
  SUBSCRIPTIONS: 'taskdata-subscriptions',
  PAYMENTS: 'taskdata-payments',
  PLANS: 'taskdata-plans',
  
  DEMO_REQUESTS: 'taskdata-demo-requests'

};